import React, { useEffect } from 'react';
const GOOGLE_REVIEW_URL = 'https://g.page/r/Cat9FuHdU1RAEBM/review';
interface GoogleReviewModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function GoogleReviewModal({
  isOpen,
  onClose
}: GoogleReviewModalProps) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  const handleLeaveReview = () => {
    window.open(GOOGLE_REVIEW_URL, '_blank', 'noopener,noreferrer');
    onClose();
  };
  const handleMaybeLater = () => {
    onClose();
  };
  return <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 99999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px'
  }} data-id="element-2521">
      {/* Backdrop */}
      <div onClick={handleMaybeLater} style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      backdropFilter: 'blur(4px)'
    }} data-id="element-2522" />

      {/* Modal Card */}
      <div style={{
      position: 'relative',
      backgroundColor: '#ffffff',
      borderRadius: '20px',
      padding: '32px 28px',
      maxWidth: '420px',
      width: '100%',
      boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
      textAlign: 'center',
      zIndex: 1
    }} data-id="element-2523">
        {/* Close button */}
        <button onClick={handleMaybeLater} style={{
        position: 'absolute',
        top: '16px',
        right: '16px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#9ca3af',
        fontSize: '20px',
        lineHeight: 1,
        padding: '4px'
      }} aria-label="Close" data-id="element-2524">
          ✕
        </button>

        {/* Google Stars Icon */}
        <div style={{
        marginBottom: '16px'
      }} data-id="element-2525">
          <div style={{
          width: '72px',
          height: '72px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #4285F4 0%, #34A853 50%, #FBBC05 75%, #EA4335 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 16px',
          fontSize: '32px'
        }} data-id="element-2526">
            ⭐
          </div>

          {/* Star rating display */}
          <div style={{
          fontSize: '28px',
          letterSpacing: '4px',
          marginBottom: '8px'
        }} data-id="element-2527">
            ⭐⭐⭐⭐⭐
          </div>
        </div>

        {/* Heading */}
        <h2 style={{
        fontSize: '22px',
        fontWeight: '700',
        color: '#111827',
        marginBottom: '12px',
        lineHeight: '1.3'
      }} data-id="element-2528">
          Enjoying the app? 🎉
        </h2>

        {/* Body text */}
        <p style={{
        fontSize: '15px',
        color: '#6b7280',
        lineHeight: '1.6',
        marginBottom: '8px'
      }} data-id="element-2529">
          You've completed{' '}
          <strong style={{
          color: '#111827'
        }} data-id="element-2530">
            5 scans
          </strong>{' '}
          — that's amazing!
        </p>
        <p style={{
        fontSize: '15px',
        color: '#6b7280',
        lineHeight: '1.6',
        marginBottom: '28px'
      }} data-id="element-2531">
          Would you mind taking a moment to leave us a Google review? It helps
          us reach more people who need this tool. 💙
        </p>

        {/* CTA Button */}
        <button onClick={handleLeaveReview} style={{
        width: '100%',
        padding: '14px 24px',
        backgroundColor: '#4285F4',
        color: '#ffffff',
        border: 'none',
        borderRadius: '12px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        marginBottom: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        transition: 'background-color 0.2s'
      }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#3367d6'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#4285F4'} data-id="element-2532">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="white" data-id="element-2533">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-2534" />
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-2535" />
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-2536" />
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-2537" />
          </svg>
          Leave a Google Review
        </button>

        {/* Secondary action */}
        <button onClick={handleMaybeLater} style={{
        width: '100%',
        padding: '12px 24px',
        backgroundColor: 'transparent',
        color: '#9ca3af',
        border: '1px solid #e5e7eb',
        borderRadius: '12px',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'color 0.2s, border-color 0.2s'
      }} onMouseEnter={e => {
        e.currentTarget.style.color = '#6b7280';
        e.currentTarget.style.borderColor = '#d1d5db';
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#9ca3af';
        e.currentTarget.style.borderColor = '#e5e7eb';
      }} data-id="element-2538">
          Maybe later
        </button>
      </div>
    </div>;
}
export default GoogleReviewModal;